import type { SVGProps } from 'react';

export function IconChevronRight(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            <polyline points="9 18 15 12 9 6" />
        </svg>
    );
}
